import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/preparer/clients')({
  component: ClientsLayout,
});

function ClientsLayout() {
  return <Outlet />;
}
